import { AbsoluteFill } from "remotion";
import { COLORS, FONTS, LOGO, BADGE, GLOBS } from "./theme";
import { Background } from "./Background";

export const Carrossel: React.FC<{
  title: string;
  badge: string;
  cta: string;
}> = ({ title, badge, cta }) => {
  return (
    <AbsoluteFill
      style={{
        background: COLORS.lightWarm,
        fontFamily: FONTS.sans,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 60,
      }}
    >
      <Background theme="light" />

      <div
        style={{
          position: "absolute",
          right: -150,
          top: -100,
          width: 500,
          height: 500,
          borderRadius: "50%",
          background: GLOBS.goldLarge,
          filter: "blur(60px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          left: -120,
          bottom: -100,
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: GLOBS.softGlow,
          filter: "blur(50px)",
        }}
      />

      <div
        style={{
          position: "absolute",
          top: 80,
          right: 60,
          width: 200,
          height: 200,
          borderRadius: "50%",
          border: "1px solid rgba(197,160,89,0.12)",
          opacity: 0.5,
        }}
      />

      <div
        style={{
          position: "absolute",
          top: 40,
          left: 40,
          display: "flex",
          alignItems: "center",
          gap: 10,
          zIndex: 2,
        }}
      >
        <div style={LOGO}>E</div>
        <span
          style={{
            fontSize: 12,
            color: COLORS.stoneMuted,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            fontWeight: 500,
          }}
        >
          Analista Corporal
        </span>
      </div>

      <div style={{ marginBottom: 28, zIndex: 2 }}>
        <span style={BADGE}>{badge}</span>
      </div>

      <div
        style={{
          fontFamily: FONTS.serif,
          fontSize: 80,
          fontWeight: 400,
          color: COLORS.textDark,
          lineHeight: 1.05,
          textAlign: "center",
          letterSpacing: "-0.03em",
          maxWidth: "80%",
          marginBottom: 40,
          zIndex: 2,
          textShadow: "0 2px 8px rgba(0,0,0,0.03)",
        }}
      >
        {title}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          color: COLORS.stoneMuted,
          fontSize: 15,
          letterSpacing: "0.05em",
          fontWeight: 500,
          zIndex: 2,
        }}
      >
        <span>{cta}</span>
        <span style={{ fontSize: 20 }}>→</span>
      </div>

      <div
        style={{
          position: "absolute",
          bottom: 30,
          display: "flex",
          gap: 8,
          zIndex: 2,
        }}
      >
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: i === 0 ? COLORS.gold : COLORS.border,
              boxShadow: i === 0 ? `0 0 8px ${COLORS.gold}40` : "none",
            }}
          />
        ))}
      </div>
    </AbsoluteFill>
  );
};
